/** Reviewed general-conversation invitations; no dispatch or live tracking promises. */
export const conversationIdeas = [
  {value:'افهم خدمات رافد', label:'إجابات تساعدك على معرفة الخطوة التالية', question:'كيف أطلب النقل المدرسي لابني؟'},
  {value:'اعرف كيف تتصرف', label:'إرشاد للشكاوى ومخاوف الرحلة', question:'الحافلة تتأخر كل يوم، ماذا أفعل؟'},
  {value:'استكشف ما على الشاشة', label:'شرح مبسّط للمعلومات والمؤشرات', question:'ماذا تعني مؤشرات أداء رافد؟'},
  {value:'تحدّث بلغتك', label:'ابدأ بطريقتك واطلب التوضيح متى احتجت', question:'Can you explain school transport in English?'},
];
